// 每題作答時間（payload 的 ct）。
// 以 survey model 為 key 共用一份，交卷（useSubmitAnswers）、暫存（useSurveyAnswerConverter）、
// 續填（useLoadProgress）三方讀寫同一個物件。
// 規則：
// - 受訪者改動答案才蓋時間（改答案 → 新時間；被跳題清空 → 刪除，之後重答再蓋新時間）
// - 續填還原期間的 setValue 也會觸發 onValueChanged，此時不蓋時間，改用 LoadAnswers 帶回的 ct
const stores = new WeakMap()

const getStore = (survey) => {
  let store = stores.get(survey)
  if (!store) {
    store = { times: {}, restoring: false }
    stores.set(survey, store)
  }
  return store
}

const isEmptyValue = (value) =>
  value === undefined ||
  value === null ||
  value === '' ||
  (Array.isArray(value) && value.length === 0) ||
  (typeof value === 'object' &&
    !Array.isArray(value) &&
    Object.keys(value).length === 0)

/** 取得該問卷的 { 題名: ct } 物件（同一個 survey 永遠回同一個物件） */
export const getAnswerTimestamps = (survey) => getStore(survey).times

/** onValueChanged 呼叫：受訪者改答案蓋新時間；續填還原期間略過 */
export const stampAnswerTime = (survey, name, value) => {
  const store = getStore(survey)
  // 改「其他」說明文字（qX-Comment）也算改了本題答案。
  // 清空不寫回：跳題 clearValue 會先刪本題 ct 再清 comment，寫回會留下清空當下的時間
  const commentOf = /^(q\d+)-Comment$/.exec(name)
  if (commentOf) {
    const parent = commentOf[1]
    if (isEmptyValue(value)) return
    if (store.restoring && parent in store.times) return
    store.times[parent] = Date.now()
    return
  }
  // 還原期間只保護已帶回 ct 的題；沒存過的題（還原途中被作答/帶值）照常蓋時間
  if (store.restoring && name in store.times) return
  if (isEmptyValue(value)) {
    delete store.times[name]
  } else {
    store.times[name] = Date.now()
  }
}

/** 續填開始：寫回 LoadAnswers 的 ct，並暫停 stampAnswerTime */
export const beginRestoreAnswerTimes = (survey, savedAnswers) => {
  const store = getStore(survey)
  store.restoring = true
  const now = Date.now()
  ;(savedAnswers || []).forEach((item) => {
    const name = `q${item.qi}`
    const ct = Number(item.ct)
    // 舊資料沒有 ct 時固定在還原當下，避免每次暫存都 fallback 成新的 Date.now()
    store.times[name] = Number.isFinite(ct) && ct > 0 ? ct : now
  })
}

/** 續填還原（含延遲設定 comment、強制刷新 UI）全部結束後呼叫 */
export const endRestoreAnswerTimes = (survey) => {
  getStore(survey).restoring = false
}
